var _circle, _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10.6667,
    height: 10.6667,
    transform: "translate(3 3)",
    fill: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28982 13.0002C6.86225 13.0002 6.51562 12.6535 6.51562 12.226V11.9651C6.51562 11.6816 6.74545 11.4518 7.02896 11.4518V11.4518C7.31246 11.4518 7.54229 11.2219 7.54229 10.9384V8.83656C7.54229 8.55305 7.31246 8.32322 7.02896 8.32322V8.32322C6.74545 8.32322 6.51562 8.09339 6.51562 7.80989V7.54393C6.51562 7.11355 6.86452 6.76465 7.29491 6.76465H7.81609C8.53431 6.76465 9.11655 7.34688 9.11655 8.06511V10.9202C9.11655 11.2055 9.34784 11.4368 9.63315 11.4368V11.4368C9.91846 11.4368 10.1497 11.6681 10.1497 11.9534V12.2185C10.1497 12.6502 9.79978 13.0002 9.36808 13.0002H7.28982Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08619 3.66699C8.65749 3.67064 9.11976 4.13257 9.12378 4.70383C9.11211 5.2868 8.63632 5.75309 8.05334 5.75309C7.48896 5.73887 7.03759 5.27949 7.0332 4.71513C7.04268 4.13835 7.50935 3.6739 8.0861 3.66699H8.08619Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.6984c9e26156ad7a699baab0a6b0de1c.svg";
export { ForwardRef as ReactComponent };